import { render, staticRenderFns } from "./AppointmentBookedOrigin.vue?vue&type=template&id=2c745cd0"
import script from "./AppointmentBookedOrigin.vue?vue&type=script&lang=ts"
export * from "./AppointmentBookedOrigin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports